var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-questions-container"},[_vm._m(0),_c('p',{staticClass:"no-questions-text"},[_vm._v(_vm._s(_vm.t('OOPS! Something went wrong. Try again later.'))+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("@/assets/no-service.png"),"alt":"no service"}})])
}]

export { render, staticRenderFns }